var React = require('react');
var ReactNative = require('react-native');

var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager.js');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpButton = require('./ReUpButton.js');
var ReUpField = require('./ReUpField.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ReUpText = require('./ReUpText');
var LinkingManager = require('./wrappers/LinkingManager');
var Animated = require('./wrappers/Animated');
var ProgressOverlay = require('./ProgressOverlay.js');
var NumericalInput = require('./NumericalInput');
var ReUpScrollView = require('./ReUpScrollView');
require('./style.css');
var Icon = require('./wrappers/ReUpIcon');
// import {CheckBox} from 'react-native-web';
var createReactClass = require('create-react-class');
var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKColor,
  MKCardStyles,
  MKTextField,
  MKIconToggle
} = MK;

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  Platform,
  StyleSheet,
    TextInput,
    Linking
} = ReactNative;

var SimpleCFD = createReactClass(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      hasValidPhone:false,
      errorMessage:"",
      isShowingPhone:true,
      isShowingSuccess:false,
      isShowingSpinner:false,

      inputWidth:new Animated.Value(this.props.initialLayout.width/3),
      isShowingPhoneKeyboard:true,
      thankYouOpacity:new Animated.Value(0),
      inputOpacity:new Animated.Value(1),
      showInput:true,
      showThankYou:false,
      showTextMe:false,
      thankYouKey:"CHECK_MESSAGES_SIGNUP",
      phoneNumber:"",
      phoneLocales: [{"Region":"CA","Code":"1"}],
      countryCode:""
    }
  },

  componentDidMount : function()
  {
    this._scrollView.doOnlineUpdate();
  },

  componentWillReceiveProps: function(newProps)
  {
    if( typeof newProps.initialLayout !== 'undefined' )
    {
      if( this._isShowingThankYou )
      {
        this.setState({inputWidth:new Animated.Value(this.props.initialLayout.width)})
      }
      else
      {
        this.setState({inputWidth:new Animated.Value(this.props.initialLayout.width/3)})
      }
    }
  },

  didUpdate : function(data)
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    this.props.appManager.getDataType("PhoneLocales", function(data)
    {
      if( typeof data !== 'undefined' && data != null )
      {
        thisThing.setState({phoneLocales:data.reverse()});
      }
    })
  },

  resetRecaptcha: function()
  {
    window.parent.postMessage({ resetRecaptchaToken: true }, '*');
  },

  textLink: function()
  {
    this.setState({isShowingSpinner:true});
    var thisThing = this;
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var phone = this.state.phoneNumber;
    var countryCode = this._ref_phoneInput._phoneInput.getCountryCode();
    var recaptchaToken = localStorage.getItem('recaptchaToken');
    NetworkManager.createUserByPhone(appManager, phone,countryCode, recaptchaToken,  ()=>
      {
          this.setState({isShowingSpinner:false});
          this.resetRecaptcha();
          thisThing.showThankYou();
      }, (error)=>
      {
          thisThing.setState({isShowingSpinner:false});
          if( typeof error !== 'undefined' && error.code == -69 )
          {
              thisThing.setState({thankYouKey:"CHECK_MESSAGES_LOGIN"});
              thisThing.showThankYou();
          }
          else
          {
              thisThing.setState({errorMessage:locManager.localizedStringForKey("INVALID_PHONE_ERROR", "Invalid phone number")})
          }
          this.resetRecaptcha();
      });
    },
    

  isHorizontal: function()
  {
    return this.props.initialLayout.width > this.props.initialLayout.height
  },

  _isShowingThankYou: false,
  showThankYou: function()
  {
    if( this._isShowingThankYou ) return;
    this._isShowingThankYou = true;

    if( this._showInputTimeout != null )
    {
      clearTimeout(this._showInputTimeout);
      this._showInputTimeout = null;
    }

    var thisThing = this;
    this._showInputTimeout = setTimeout(()=>
    {
      thisThing.showNumberInput();
    }, 20000);

    Animated.timing(
      thisThing.state.inputOpacity,
      {
        toValue: 0,
        duration: 400
      }
    ).start(function()
    {
      thisThing.setState({showThankYou:true, showInput:false});
      Animated.timing(
        thisThing.state.thankYouOpacity,
        {
          toValue: 1,
          duration: 400
        }
      ).start(function()
      {

      });
    });

    Animated.timing(
      thisThing.state.inputWidth,
      {
        toValue: this.props.initialLayout.width,
        duration: 800
      }
    ).start(function()
    {

    });
  },

  _showInputTimeout: null,
  showNumberInput: function()
  {

    if( !this._isShowingThankYou ) return;
    this._isShowingThankYou = false;

    if( this._showInputTimeout != null )
    {
      clearTimeout(this._showInputTimeout);
      this._showInputTimeout = null;
    }

    var thisThing = this;
    Animated.timing(
      thisThing.state.thankYouOpacity,
      {
        toValue: 0,
        duration: 400
      }
    ).start(function()
    {
      thisThing.setState({thankYouKey: "CHECK_MESSAGES_SIGNUP", showThankYou:false, showInput:true, showTextMe:false});
      Animated.timing(
        thisThing.state.inputOpacity,
        {
          toValue: 1,
          duration: 400
        }
      ).start(function()
      {

      });
    });

    Animated.timing(
      thisThing.state.inputWidth,
      {
        toValue: this.props.initialLayout.width/3,
        duration: 800
      }
    ).start(function()
    {

    });
  },

  _phoneNumber:"",
  hasValidPhone: function(phoneNumber)
  {
    if( typeof phoneNumber === 'undefined' ) phoneNumber = this.state.phoneNumber;

    return phoneNumber.length > 1;
  },

  setPhoneNumber: function(phoneNumber)
  {
    if( this.state.phoneNumber == phoneNumber ) return;

    this.setState({phoneNumber, showTextMe:this.hasValidPhone(phoneNumber), errorMessage:""})
  },

  render: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = appManager.getLocalizationManager();

    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var headerColor = appManager.getColorForKey("HeaderColor");
    var headerIconColor = appManager.getColorForKey("HeaderIconColor");
    var headerTitleColor = appManager.getColorForKey("HeaderTitleColor");
    var profileColor = appManager.getColorForKey("ProfileColor");
    var profileTitleColor = appManager.getColorForKey("ProfileTitleColor");
    var profileIconColor = appManager.getColorForKey("ProfileIconColor");
    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
    var buttonPrimaryColor = appManager.getColorForKey("ButtonPrimaryColor");
    var isHorizontal = false; //this.isHorizontal();
    if( isHorizontal )
    {
      var backgroundImage = appManager.absoluteResourceForPath("Feed/background.png");
      var iconImage = appManager.absoluteResourceForPath("App/iTunesArtwork.png");
      var ratio = 230.0 / 170.0; // h / w
      var maxWidth = (this.props.initialLayout.width/3) - 20;
      var maxHeight = this.props.initialLayout.height - 170;
      var inputWidth = maxWidth;
      var inputHeight = Math.min(maxHeight, inputWidth*ratio);
      // inputWidth = inputHeight / ratio;

      var iconDim = this.props.initialLayout.height / 4;

      return(
        <View style={{flexDirection:'row', alignItems:'stretch', backgroundColor:headerColor, height:this.props.initialLayout.height, width:this.props.initialLayout.width}}>
          <View style={{flex:2, flexDirection:'column'}}>
            <View style={{position:'absolute', top:0, left:0, right:0, bottom:0}}>
              <Image style={{width:'100%', height:this.props.initialLayout.height}} resizeMode={"cover"} source={{uri: backgroundImage}} />
            </View>
            <View style={{flex:3}} />
            <View style={{alignSelf:'center'}}>
              <Image style={{width:iconDim, height:iconDim, borderRadius: iconDim / 10}} resizeMode={"contain"} source={{uri: iconImage}} />
            </View>
            <View style={{flex:1}} />
            <View style={{alignSelf:'center'}}>
              <ReUpText appManager={appManager} isTitle={true} style={{color:generalColor, textAlign:'center', marginBottom:10, fontSize:this.props.initialLayout.height/10}}>
              {locManager.localizedStringForKey("EARN_POINTS_STATEMENT_4")}
              </ReUpText>
              <ReUpText appManager={appManager} style={{color:generalColor, textAlign:'center', fontSize:this.props.initialLayout.height/15}}>
              {locManager.localizedStringForKey("ON_EVERY_PURCHASE_STATEMENT")}
              </ReUpText>
            </View>
            <View style={{flex:6}} />
          </View>
          <View style={{flex:1}} />
          <Animated.View style={{position:'absolute', flexDirection:'column', backgroundColor:profileColor, top:0, bottom:0, right:0, width: this.state.inputWidth}}>
          {
            this.state.showInput ?
              <Animated.View style={{flex:1, alignSelf:'stretch', alignItems:'center', justifyContent:'center', opacity:this.state.inputOpacity}}>
                <View style={{height:inputHeight, width:inputWidth, backgroundColor:'transparent', marginRight:9}}>
                  <NumericalInput ref={(c) => { this._ref_phoneInput = c; }}
                    style={{height:inputHeight, width:inputWidth}}
                    isPhoneNumber={true}
                    appManager={this.props.appManager}
                    initialValue={""}
                    inputTextColor={profileTitleColor}
                    previewStyle={{fontFamily:'Courier', fontSize:inputHeight/15, color:profileTitleColor, borderColor:profileMeterColor}}
                    valueChanged={(newValue,newStringValue)=>
                    {
                      var phoneNumber = thisThing._ref_phoneInput.strippedPhoneNumber(newValue);
                      thisThing.setPhoneNumber(phoneNumber);
                    }}
                  />
                </View>
                <View style={{height:inputHeight/5, marginTop:20, marginLeft:2, alignSelf:'center', alignItems:'stretch', justifyContent:'center'}}>
                {
                  this.state.showTextMe && this.state.errorMessage == "" ?
                    <ReUpButton appManager={appManager} isSecondary={true} style={{flex:1, height:inputHeight/5, width:inputWidth-6}} fontSize={this.props.initialLayout.height/25} text={locManager.localizedStringForKey("TEXT_ME_BUTTON")}
                      onPress={()=>
                      {
                        thisThing.textLink();
                      }} />
                  :
                    <ReUpText appManager={appManager} isTitle={true} style={{color:profileTitleColor, textAlign:'center', fontSize:this.props.initialLayout.height/40}}>
                    {this.state.errorMessage}
                    </ReUpText>
                }
                </View>
              </Animated.View>
            : null
          }
          {
            this.state.showThankYou ?
                <Animated.View style={{flex:1, alignSelf:'stretch', margin:20, justifyContent: 'stretch', backgroundColor:profileColor, opacity:this.state.thankYouOpacity}}>
                  <View style={{flexDirection: "column", justifyContent: "space-around", height: '100%'}} >
                    <View style={{flex:1,justifyContent: "flex-end", alignSelf:'center'}}>
                      <Image style={{width:iconDim/2, height:iconDim/2, borderRadius: iconDim / 10}} resizeMode={"contain"} source={{uri: iconImage}} />
                    </View>

                    <ReUpText appManager={appManager} isTitle={true} style={{flex:0.15,alignSelf:'center', color:profileTitleColor, textAlign:'center', marginTop:20, fontSize:"20px"}}>
                      {locManager.localizedStringForKey("THANKS_STATEMENT")}
                    </ReUpText>
                    <ReUpText appManager={appManager} style={{flex:1,alignSelf:'center', color:profileTitleColor, textAlign:'center', fontSize:"18px"}}>
                      {locManager.localizedStringForKey(this.state.thankYouKey)}
                    </ReUpText>
                  </View>

                </Animated.View>
            : null
          }
          </Animated.View>
          {
            this.state.isShowingSpinner ?
            <ProgressOverlay ref={(c) => { this._ref_spinner = c; }} key="spinner" isVisible={this.state.isShowingSpinner}
              layout={this.props.initialLayout} appManager={appManager}>
            </ProgressOverlay>
            : null
          }
        </View>
      )
    }

    var stripHeight = this.props.initialLayout.width * 123 / 375;

    var stripImage = appManager.absoluteResourceForPath("MyCard/strip.png");
    var headerImage = appManager.absoluteResourceForPath("Feed/header.png");

    var backgroundImage = appManager.absoluteResourceForPath("Feed/background.png");
    var iconImage = appManager.absoluteResourceForPath("App/iTunesArtwork.png");
    var ratio = 230.0 / 190.0; // h / w
    var maxWidth = this.props.initialLayout.width - 20;
    var maxHeight = this.props.initialLayout.height - stripHeight - 170;
    var inputWidth = maxWidth;
    var inputHeight = Math.min(maxHeight, inputWidth*ratio);
    var privacyURL = locManager.localizedStringForKey("PRIVACY_URL");
    var tacURL = appManager.getTermsLink() ;
    var recaptchaLocale = appManager.getActiveLocale();
    if (recaptchaLocale=='' || recaptchaLocale == null) {
      recaptchaLocale = 'en';
    }else {
      recaptchaLocale=recaptchaLocale.substr(0,2)
    }
    // inputWidth = inputHeight / ratio;

    var iconDim = this.props.initialLayout.height / 4;


    return(
      <View style={{flexDirection:'row', alignItems:'stretch', backgroundColor:profileColor, height:'100%', width:'100%'}}>
      <ReUpScrollView ref={(a) => { this._scrollView = a }} responder={this}>
      {
        this.state.showInput ?
          <Animated.View style={{height: '100%', flex:-1, alignSelf:'stretch', alignItems:'center', justifyContent:'center', opacity:this.state.inputOpacity}}>
            <View style={{height:stripHeight, backgroundColor:headerIconColor, alignSelf:'stretch'}}>
              <Image style={{width:'100%', height:stripHeight}} resizeMode={"cover"} source={{uri: stripImage}} />
              <View style={{position:'absolute', top:20, left:20, right:20, bottom:20}}>
                <Image style={{width:'100%', height:stripHeight-40}} resizeMode={"contain"} source={{uri: headerImage}} />
              </View>
            </View>


            <View style={{flex:1, flexDirection:'column', backgroundColor:'transparent', alignItems: 'stretch', paddingRight:18, paddingLeft: 18, width:'100%'}}>
              <ReUpText appManager={appManager} isTitle={true} style={{flex:0, color:profileTitleColor, textAlign:'center', paddingTop:18, paddingBottom: 18}}>
              {locManager.localizedStringForKey("ENTER_PHONE_NUMBER_STATEMENT")}</ReUpText>
              <NumericalInput ref={(c) => { this._ref_phoneInput = c; }}
                style={{flex:1, minHeight: 55}}
                isPhoneNumber={true}
                appManager={this.props.appManager}
                initialValue={locManager.localizedStringForKey("PHONE_NUMBER")}
                inputTextColor={profileTitleColor}
                phoneLocales={this.state.phoneLocales}
                isInError = {this.state.errorMessage.length > 0}
                previewStyle={{color:generalTitleColor, borderColor:profileMeterColor, paddingTop: 8, paddingBottom:8}}
                valueChanged={(newValue,newStringValue)=>
                {
                  var phoneNumber = thisThing._ref_phoneInput.strippedPhoneNumber(newValue);
                  thisThing.setPhoneNumber(phoneNumber);
                }}
              />

              <ReUpText appManager={appManager} isTitle={true} style={{color:  appManager.getErrorColor(), textAlign:'center', fontSize:"13px"}}>
                {this.state.errorMessage}
              </ReUpText>
              <ReUpText appManager={appManager} isTitle={false} style={{flex:0.25, color:profileTitleColor, opacity: 0.5, textAlign:'center', marginTop:18, marginBottom:18, fontSize:"11px"}}>
                {locManager.localizedStringForKey("SMS_WARNING_TEXT")}</ReUpText>

              <View style={{flex:-1, justifyContent: 'center', backgroundColor:'transparent', flexDirection:'row'}}>

              <Text onPress={ ()=>{ Linking.openURL(privacyURL)} } appManager={appManager} isTitle={true} style={{color:profileMeterColor, fontSize:"10px", textAlign:'center', padding:18}}>
                {locManager.localizedStringForKey("PRIVACY_LABEL")}</Text>
              <Text onPress={ ()=>{ Linking.openURL(tacURL)} } appManager={appManager} isTitle={true} style={{color:profileMeterColor, fontSize:"10px",textAlign:'center', padding:18}}>
                {locManager.localizedStringForKey("TAC_LABEL")}</Text>

                </View>
                <View style={{flex: 2, justifyContent:'flex-end'}}>
                  {/* This recaptcha element is effectively not used, all of the loading of the topken happens in the parent of the iframe in recaptchaLoader.js */}
              </View>
              <View style={{flex:1, marginBottom:18, alignSelf:'stretch', alignItems:'stretch', justifyContent:'flex-end'}}>
                {
                  this.state.showTextMe && this.state.errorMessage == "" ?
                      <ReUpButton appManager={appManager} maskBorderRadius={40} style={{ minHeight: '60px', maxHeight:'60px',flex:1}} fontSize={20} text={locManager.localizedStringForKey("CONTINUE_BUTTON")}
                                  onPress={()=>
                                  {
                                    thisThing.textLink();
                                  }} />
                      :null

                }

              </View>

            </View>


          </Animated.View>
        : null
      }
      {
        this.state.showThankYou ?
            <Animated.View style={{flex:1, alignSelf:'stretch', margin:20, justifyContent: 'stretch', backgroundColor:profileColor, opacity:this.state.thankYouOpacity}}>
              <View style={{flexDirection: "column", justifyContent: "space-around", height: '100%'}} >
              <View style={{flex:1,justifyContent: "flex-end", alignSelf:'center'}}>
                <Image style={{width:iconDim/2, height:iconDim/2, borderRadius: iconDim / 10}} resizeMode={"contain"} source={{uri: iconImage}} />
              </View>

                <ReUpText appManager={appManager} isTitle={true} style={{flex:0.15,alignSelf:'center', color:profileTitleColor, textAlign:'center', marginTop:20, fontSize:"20px"}}>
                  {locManager.localizedStringForKey("SENT_LINK")}
                </ReUpText>
                <ReUpText appManager={appManager} style={{flex:1,alignSelf:'center', color:profileTitleColor, textAlign:'center', fontSize:"18px"}}>
                  {locManager.localizedStringForKey(this.state.thankYouKey)}
                </ReUpText>
              </View>

            </Animated.View>
        : null
      }
      {
        this.state.isShowingSpinner ?
        <ProgressOverlay ref={(c) => { this._ref_spinner = c; }} key="spinner" isVisible={this.state.isShowingSpinner}
          layout={this.props.initialLayout} appManager={appManager}>
        </ProgressOverlay>
        : null
      }
      </ReUpScrollView>
    </View>
    )

    var phoneSeparators = ["(",") "," - "];

    // return (
    //   <View key="feedPlusView" ref={(a)=>{if( a != null ) thisThing._feedPlusView = a}}
    //     style={{backgroundColor:headerColor, flexDirection:'column', flex:1, alignSelf:'stretch', height:this.props.initialLayout.height-(2*this.state.verticalMargin)}}>
    //     <View style={{height:30}}>
    //     </View>
    //     <View style={{height:stripHeight, backgroundColor:headerIconColor}}>
    //       <Image style={{width:'100%', height:stripHeight}} resizeMode={"cover"} source={{uri: stripImage}} />
    //       <View style={{position:'absolute', top:20, left:20, right:20, bottom:20}}>
    //         <Image style={{width:'100%', height:stripHeight-40}} resizeMode={"contain"} source={{uri: headerImage}} />
    //       </View>
    //     </View>
    //     <View style={{flexDirection:'column', alignItems:'center', marginTop:40, marginLeft:20, marginRight:20}}>
    //       <ReUpText appManager={appManager} isTitle={true} style={{color:headerTitleColor, textAlign:'center', marginBottom:4}}>
    //       {"Enter your phone number below to receive a login link."}
    //       </ReUpText>
    //     </View>
    //     <View style={{flexDirection:'row', alignItems:'center', justifyContent:'center'}}>
    //       <View style={{alignItems:'center', justifyContent:'center', flex:1, flexDirection:'row'}}>
    //         <ReUpText appManager={appManager} style={{marginTop:18, padding:4, fontSize:24}}>{phoneSeparators[0]}</ReUpText>
    //         <ReUpField
    //           appManager={appManager}
    //           ref={(a)=>{thisThing._phone1=a}}
    //           key="phone1"
    //           keyboardType={"phone-pad"}
    //           onKeyPress={(event)=>
    //           {
    //             if( event.nativeEvent.key == "Backspace" ) thisThing.backSpacePressed("phone1")
    //           }}
    //           onChangeText={(text) =>
    //           {
    //             thisThing._phoneText1 = text;
    //             var hasValidPhone = thisThing.hasValidPhone();
    //             if( thisThing.state.hasValidPhone != hasValidPhone ) thisThing.setState({hasValidPhone});
    //             if( text.length >= 3 ) thisThing._phone2.focus()
    //             thisThing.setIsInError(false);
    //           }}
    //           placeholder={thisThing._phoneText1Placeholder}
    //           maxLength={3}
    //           isInError={this.state.isInError}
    //           style={{flex:-1, width:45}}/>
    //         <ReUpText appManager={appManager} style={{flex:-1, marginTop:18, padding:4, fontSize:24}}>{phoneSeparators[1]}</ReUpText>
    //         <ReUpField
    //           appManager={appManager}
    //           ref={(a)=>{thisThing._phone2=a}}
    //           key="phone2"
    //           keyboardType={"phone-pad"}
    //           onKeyPress={(event)=>
    //           {
    //             if( event.nativeEvent.key == "Backspace" ) thisThing.backSpacePressed("phone2")
    //           }}
    //           onChangeText={(text) =>
    //           {
    //             thisThing._phoneText2 = text;
    //             var hasValidPhone = thisThing.hasValidPhone();
    //             if( thisThing.state.hasValidPhone != hasValidPhone ) thisThing.setState({hasValidPhone});
    //             if( text.length >= 3 ) thisThing._phone3.focus()
    //             thisThing.setIsInError(false);
    //           }}
    //           placeholder={thisThing._phoneText2Placeholder}
    //           maxLength={3}
    //           isInError={this.state.isInError}
    //           style={{flex:-1, width:45}}/>
    //         <ReUpText appManager={appManager} style={{flex:-1, marginTop:18, padding:4, fontSize:24}}>{phoneSeparators[2]}</ReUpText>
    //         <ReUpField
    //           appManager={appManager}
    //           ref={(a)=>{thisThing._phone3=a}}
    //           key="phone3"
    //           keyboardType={"phone-pad"}
    //           onKeyPress={(event)=>
    //           {
    //             if( event.nativeEvent.key == "Backspace" ) thisThing.backSpacePressed("phone3")
    //           }}
    //           onChangeText={(text) =>
    //           {
    //             thisThing._phoneText3 = text;
    //             var hasValidPhone = thisThing.hasValidPhone();
    //             if( thisThing.state.hasValidPhone != hasValidPhone ) thisThing.setState({hasValidPhone});
    //             thisThing.setIsInError(false);
    //           }}
    //           placeholder={thisThing._phoneText3Placeholder}
    //           maxLength={4}
    //           isInError={this.state.isInError}
    //           style={{flex:-1,width:65}}/>
    //       </View>
    //       {
    //         this.state.errorMessage != null ?
    //           <View>
    //             <ReUpText appManager={appManager} style={{color:'red', alignSelf:'center', margin:10}}>
    //             {this.state.errorMessage}
    //             </ReUpText>
    //           </View>
    //         : null
    //       }
    //     </View>
    //     <View style={{flexDirection:'column', alignItems:'center', marginTop:40}}>
    //       <ReUpButton appManager={appManager} isSecondary={true} style={{width:240}} text={"Text Me"}
    //         onPress={()=>
    //         {
    //           thisThing.submitNewPhone();
    //         }} />
    //     </View>
    //     <View style={{flex:1}} />
    //   </View>
    // )
return null;
    // return(
    //   <View style={[styles.container, {backgroundColor:headerColor, height:this.props.initialLayout.height, width:this.props.initialLayout.width}]}>
    //     <View style={{width:this.props.initialLayout.width, height:stripHeight, backgroundColor:headerIconColor}}>
    //       <Image style={{width:this.props.initialLayout.width, height:stripHeight}} resizeMode={"cover"} source={{uri: stripImage}} />
    //       <View style={{position:'absolute', top:20, left:20, right:20, bottom:20}}>
    //         <Image style={{width:'100%', height:stripHeight-40}} resizeMode={"contain"} source={{uri: headerImage}} />
    //       </View>
    //     </View>
    //     <View style={{flex:1}} />
    //     {
    //       this.state.isShowingPhone ?
    //         <View style={{alignSelf:'stretch', flexDirection:'column'}}>
    //           <View style={{paddingRight:8, alignItems:'center', justifyContent:'center', flexDirection:'row'}}>
    //             <ReUpText appManager={appManager} style={{marginTop:18, padding:4, fontSize:24}}>{phoneSeparators[0]}</ReUpText>
    //             <ReUpField
    //               appManager={appManager}
    //               ref={(a)=>{thisThing._phone1=a}}
    //               key="phone1"
    //               keyboardType={"phone-pad"}
    //               onKeyPress={(event)=>
    //               {
    //                 if( event.nativeEvent.key == "Backspace" ) thisThing.backSpacePressed("phone1")
    //               }}
    //               onChangeText={(text) =>
    //               {
    //                 thisThing._phoneText1 = text;
    //                 var hasValidPhone = thisThing.hasValidPhone();
    //                 if( thisThing.state.hasValidPhone != hasValidPhone ) thisThing.setState({hasValidPhone});
    //                 if( text.length >= 3 ) thisThing._phone2.focus()
    //                 thisThing.setIsInError(false);
    //               }}
    //               placeholder={thisThing._phoneText1Placeholder}
    //               maxLength={3}
    //               isInError={this.state.isInError}
    //               style={{flex:-1, width:45}}/>
    //             <ReUpText appManager={appManager} style={{flex:-1, marginTop:18, padding:4, fontSize:24}}>{phoneSeparators[1]}</ReUpText>
    //             <ReUpField
    //               appManager={appManager}
    //               ref={(a)=>{thisThing._phone2=a}}
    //               key="phone2"
    //               keyboardType={"phone-pad"}
    //               onKeyPress={(event)=>
    //               {
    //                 if( event.nativeEvent.key == "Backspace" ) thisThing.backSpacePressed("phone2")
    //               }}
    //               onChangeText={(text) =>
    //               {
    //                 thisThing._phoneText2 = text;
    //                 var hasValidPhone = thisThing.hasValidPhone();
    //                 if( thisThing.state.hasValidPhone != hasValidPhone ) thisThing.setState({hasValidPhone});
    //                 if( text.length >= 3 ) thisThing._phone3.focus()
    //                 thisThing.setIsInError(false);
    //               }}
    //               placeholder={thisThing._phoneText2Placeholder}
    //               maxLength={3}
    //               isInError={this.state.isInError}
    //               style={{flex:-1, width:45}}/>
    //             <ReUpText appManager={appManager} style={{flex:-1, marginTop:18, padding:4, fontSize:24}}>{phoneSeparators[2]}</ReUpText>
    //             <ReUpField
    //               appManager={appManager}
    //               ref={(a)=>{thisThing._phone3=a}}
    //               key="phone3"
    //               keyboardType={"phone-pad"}
    //               onKeyPress={(event)=>
    //               {
    //                 if( event.nativeEvent.key == "Backspace" ) thisThing.backSpacePressed("phone3")
    //               }}
    //               onChangeText={(text) =>
    //               {
    //                 thisThing._phoneText3 = text;
    //                 var hasValidPhone = thisThing.hasValidPhone();
    //                 if( thisThing.state.hasValidPhone != hasValidPhone ) thisThing.setState({hasValidPhone});
    //                 thisThing.setIsInError(false);
    //               }}
    //               placeholder={thisThing._phoneText3Placeholder}
    //               maxLength={4}
    //               isInError={this.state.isInError}
    //               style={{flex:-1,width:65}}/>
    //           </View>
    //
    //
    //           {
    //             this.state.hasValidPhone && this.state.errorMessage == null ?
    //               <View style={{padding:20, height:80}}>
    //                 <ReUpButton appManager={appManager} text={locManager.localizedStringForKey("TEXT_CFC_BUTTON", "Text Me")} onPress={()=>
    //                   {
    //                     thisThing.textLink();
    //                   }}/>
    //               </View>
    //             :
    //               <View style={{height:80, padding:20}}>
    //               {
    //                 this.state.errorMessage != null ?
    //                     <ReUpText appManager={appManager} style={{color:'red', alignSelf:'center', textAlign:'center'}}>
    //                     {this.state.errorMessage}
    //                     </ReUpText>
    //                 : null
    //               }
    //               </View>
    //           }
    //         </View>
    //       : null
    //     }
    //     {
    //       this.state.isShowingSuccess ?
    //         <View style={{padding:20}}>
    //           <ReUpText appManager={appManager} isTitle={true} style={{alignSelf:'center', margin:10}}>
    //           {"Success!"}
    //           </ReUpText>
    //           <ReUpText appManager={appManager} isTitle={false} style={{alignSelf:'center', margin:10, textAlign:'center'}}>
    //           {"A text has been sent to "+this.getPhoneNumber()+"!"}
    //           </ReUpText>
    //         </View>
    //       : null
    //     }
    //     <View style={{flex:1}} />
    //     {
    //       this.state.isShowingSpinner ?
    //       <ProgressOverlay ref="spinner" key="spinner" isVisible={this.state.isShowingSpinner}
    //         layout={this.state.layout} appManager={appManager}>
    //       </ProgressOverlay>
    //       : null
    //     }
    //   </View>
    // )
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
  }
});

SimpleCFD.dataDependencies = ["PhoneLocales"];

module.exports = SimpleCFD;
